(function(){
"use strict";
/* Scheda tecnica dal metafield dema.specifiche.
   Se il campo e' vuoto resta quella scritta in dema-product.js. */
var host=document.getElementById("spectab");
if(!host)return;
var raw=document.getElementById("demaSpecs");
if(!raw)return;
var SPEC=null;
try{SPEC=JSON.parse(raw.textContent)}catch(e){}
if(typeof SPEC==="string"){try{SPEC=JSON.parse(SPEC)}catch(e){SPEC=null}}
if(!SPEC||!SPEC.length)return;

var ICO={
 disp:'<rect x="6" y="2" width="12" height="20" rx="3"/><path d="M10 18h4"/>',
 cpu:'<rect x="7" y="7" width="10" height="10" rx="2"/><path d="M10 3v3M14 3v3M10 18v3M14 18v3M3 10h3M3 14h3M18 10h3M18 14h3"/>',
 cam:'<rect x="2.5" y="6.5" width="19" height="13" rx="3"/><circle cx="12" cy="13" r="3.4"/><path d="M8.5 6.5L10 4.5h4l1.5 2"/>',
 batt:'<rect x="2.5" y="8" width="16.5" height="8.6" rx="2.4"/><path d="M21.6 11v3M5.6 12.3h6"/>',
 net:'<path d="M3 9a13 13 0 0 1 18 0"/><path d="M6.5 12.5a8 8 0 0 1 11 0"/><path d="M10 16a3.5 3.5 0 0 1 4 0"/><circle cx="12" cy="19.5" r="1.1"/>',
 face:'<circle cx="12" cy="8.2" r="3.4"/><path d="M5.5 20c0-3.4 2.9-5.8 6.5-5.8s6.5 2.4 6.5 5.8"/>',
 peso:'<circle cx="12" cy="4.2" r="1.6"/><path d="M12 5.8v1.6"/><path d="M4 20h16"/><path d="M7.2 20l2.4-9.6h4.8L16.8 20"/>',
 port:'<rect x="5" y="2.5" width="14" height="12" rx="3.2" stroke-width="2.1"/><path d="M9.3 6.2v3.4M14.7 6.2v3.4" stroke-width="2.4"/><path d="M12 14.5v3.2" stroke-width="2.1"/><path d="M12 17.7c0 2 1.6 3.6 3.6 3.6" stroke-width="2.1"/>',
 sim:'<rect x="5" y="2.5" width="14" height="19" rx="3"/><rect x="9" y="9" width="6" height="6" rx="1.2"/>'
};
function svg(k){return '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.85" stroke-linecap="round" stroke-linejoin="round">'+(ICO[k]||ICO.cpu)+'</svg>'}
function esc(s){return String(s==null?"":s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;")}

host.innerHTML=SPEC.map(function(g){
 var rows=(g.r||[]).map(function(r){
  return '<div class="specrow"><dt>'+esc(r[0])+'</dt><dd>'+esc(r[1])+'</dd></div>';
 }).join("");
 return '<div class="sgrp"><button type="button" class="sgh"><span class="sgi">'+svg(g.i)+'</span>'+
  '<span class="sgt">'+esc(g.t)+'<span>'+esc(g.s||"")+'</span></span><span class="sgc"></span></button>'+
  '<div class="sgb"><div class="sgin">'+rows+'</div></div></div>';
}).join("");
[].forEach.call(host.children,function(el){
 el.querySelector(".sgh").addEventListener("click",function(){el.classList.toggle("on")});
});
})();
